import { INITIAL_URL } from '../../constants/storage';

export function setInitialUrl(redirectUrl: string, initialUrlPathname: string) {
  const redirectUrlPathname = new URL(redirectUrl, window.location.origin).pathname;
  if (redirectUrlPathname !== initialUrlPathname && initialUrlPathname !== '/') {
    sessionStorage.setItem(INITIAL_URL, initialUrlPathname);
  }
}

export function getInitialUrl() {
  return sessionStorage.getItem(INITIAL_URL);
}

export function isRefreshedAsLoggedUser(url: string | null): boolean {
  return Boolean(url);
}
